export default __webpack_public_path__ + "static/media/apollo.eba4a2eb.svg";